import { Component, Input, ViewChild } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslationService } from '../common/services/translation.service';
import { ILabel } from '../ILabel.model';
import { ValueAccessorBase } from '../value-accessor-base';

@Component({
    selector: 'cpq-radio-button',
    templateUrl: './cpq-radio-button.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqRadioButtonComponent,
            multi: true
        }
    ],
    styleUrls: ['./cpq-radio-button.component.scss'],
    standalone: false
})

export class CpqRadioButtonComponent extends ValueAccessorBase<any> {
    @ViewChild(NgModel, { static: true }) model: NgModel;

    @Input('name') name: string;
    @Input('buttons') buttons: Array<any>;
    @Input('label') label: ILabel;
    @Input('required') required: boolean = false;
    @Input('showLabel') showLabel: boolean = true;
    @Input('disabled') disabled: boolean = false;
    public translationService: TranslationService;

    constructor(translationService: TranslationService){
      super();
      this.translationService = translationService;
    }
}